import { getClasses, patchClass } from '@yandex-int/k-common/client/api';
import { showNetworkError } from 'platform-components';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import * as userActions from 'common.components/user/actions';
import { getArchivedClassesRequestSaga } from 'common.components/user/saga';
import { getCurrentClass, getCurrentTeamPrevLevel } from 'common.components/user/selectors';
import { getTeamIdFromPath } from 'utils/path';

import {
    actualizeClassError,
    actualizeClassSuccess,
    archiveClassError,
    archiveClassRequest,
    archiveClassSuccess,
    renameClassError,
    renameClassRequest,
    renameClassSuccess,
} from './actions';
import { ACTUALIZE_CLASS_REQUEST, ARCHIVE_TEAM, RENAME_TEAM } from './constants';
import { getNewLevel, getNewName } from './selectors';

export function* newYearSagasWatcher() {
    yield all([renameClassWatcher(), archiveClassWatcher(), actualizeClassWatcher()]);
}

function* renameClassWatcher() {
    yield takeLatest(RENAME_TEAM, renameClassSaga);
}

function* archiveClassWatcher() {
    yield takeLatest(ARCHIVE_TEAM, archiveClassSaga);
}

function* actualizeClassWatcher() {
    yield takeLatest(ACTUALIZE_CLASS_REQUEST, actualizeClassSaga);
}

function* renameClassSaga(action) {
    try {
        yield put(renameClassRequest());
        const teamId = getTeamIdFromPath();
        const letter = yield select(getNewName, { classId: teamId });
        const number = yield select(getNewLevel);

        yield call(patchClass, teamId, { number, letter, actual: true });
        const teams = yield call(getClasses);

        yield put(userActions.setTeams(teams));
        yield put(renameClassSuccess());

        const { onAfterRename } = action;
        if (onAfterRename) {
            onAfterRename();
        }
    } catch (error) {
        console.error(error);

        yield put(renameClassError(error));
        yield put(showNetworkError(error));
    }
}

function* archiveClassSaga(action) {
    try {
        const teamId = getTeamIdFromPath();
        const currentClass = yield select(getCurrentClass, { classId: teamId });
        const prevLevel = yield select(getCurrentTeamPrevLevel, { classId: teamId });

        if (!currentClass || !prevLevel) {
            return;
        }

        yield put(userActions.setWizardVariables({ newYearModalArchiveClassPressed: true }));
        yield put(archiveClassRequest());

        yield call(patchClass, teamId, { active: false, actual: true, number: prevLevel === 98 ? 99 : prevLevel });
        const teams = yield call(getClasses);

        yield call(getArchivedClassesRequestSaga);

        yield put(userActions.setTeams(teams));
        yield put(archiveClassSuccess());

        const { onAfterArchive } = action;
        if (onAfterArchive) {
            let newClassId = null;
            if (teams && teams.length) {
                newClassId = teams[0].id;
            }

            onAfterArchive(newClassId);
        }
    } catch (error) {
        console.error(error);

        yield put(archiveClassError(error));
        yield put(showNetworkError(error));
    }
}

function* actualizeClassSaga(action) {
    try {
        const teamId = getTeamIdFromPath();

        yield call(patchClass, teamId, { actual: true });
        const teams = yield call(getClasses);

        yield put(userActions.setTeams(teams));
        yield put(actualizeClassSuccess());

        const { onAfterActualize } = action;
        if (onAfterActualize) {
            onAfterActualize();
        }
    } catch (error) {
        console.error(error);

        yield put(actualizeClassError(error));
        yield put(showNetworkError(error));
    }
}
